export default "__VITE_ASSET__BRcYJ9Bn__"